

export function createOnboaringBullets(config, state) {
    const showProgress = state?.activeStep?.popover?.showProgress ?? config?.showProgress ?? false;
    const total = (config?.steps?.filter(s => s?.popover?.showProgress)?.length ?? 1);
    const current = state?.activeIndex ?? 0;

    const progressElement = document.querySelector(
        ".driver-popover-progress-text"
    );
    if (!progressElement) return;

    if (!showProgress) {
        progressElement.style = "display: none";
        return;
    }

    // Clear existing content
    progressElement.innerHTML = "";
    progressElement.style = "display: flex";

    for (let i = 1; i <= total; i++) {
        const bullet = document.createElement("span");
        bullet.className = `progress-bullet ${
            i == current ? "active" : ""
        }`;
        progressElement.appendChild(bullet);
    }
}